"use client";
import { useEffect } from "react";
import PropTypes from "prop-types";

import Container from "components/grid/container";

import { GTMPushEvent } from "@/src/helpers/google-tag-manager";
import setSearchId from "helpers/google-tag-manager/set-search-id";
import { capitalizeFirstWord } from "@/src/helpers/project-detail/logo-placeholder";

import styles from "./styles.module.css";

const Showcase = ({ data }) => {
  const { city = {}, coverPhoto, district = {}, logo, name } = data.detailData?.[0]?.company || {};
  const isCover = coverPhoto || "/assets/images/company-detail-default-cover.webp";

  useEffect(() => {
    setSearchId("companyDetail").then((searchId) => {
      GTMPushEvent({
        platform: "web-desktop",
        search_id: searchId,
        page_type: "proje-firma-detay",
        item_type: "proje",
        city: city.name,
        town: null,
        district: district.name,
        city_id: city.id,
        town_id: null,
        district_id: district.id,
        total_item: data.total,
        project_company_name: name,
        design_type: "new",
      });
    });
  }, [data]);

  return (
    <div>
      <Container className={styles.wrapper}>
        <div className={styles.logoWrapper}>
          {logo ? (
            <img className={styles.logo} src={logo} alt={name} />
          ) : (
            <div className={styles.logoPlaceholder}>{capitalizeFirstWord(name)}</div>
          )}
          <div className={styles.line} />
          <h1 className={styles.title}>{name}</h1>
        </div>
      </Container>
      <img className={styles.cover} src={isCover} alt={name} />
    </div>
  );
};

Showcase.propTypes = {
  data: PropTypes.object,
};
export default Showcase;
